<template>
	<div>
		<!-- 总部的账号设置start -->
		<admin-account-manage v-if="role=='hq_admin'" />
		<!-- 总部的账号设置end -->
		
		<!-- 门店的账号设置start -->
		<store-account-manage v-if="role=='store_admin'||role=='store_sa'" />
		<!-- 门店的账号设置end -->
		
		<!-- 教练的账号设置start -->
		<editor-account-manage v-if="role=='store_editor'" />
		<!-- 教练的账号设置end -->
	</div>
</template>

<script>
	import adminAccountManage from './adminAccountManage.vue'
	import storeAccountManage from './storeAccountManage.vue'
	import editorAccountManage from './editorAccountManage.vue'
	export default {
		name: 'orderList',
		components: {
			adminAccountManage,
			storeAccountManage,
			editorAccountManage
		},
		data() {
			return {
				role:'',
			}
		},
		mounted() {
			
			this.role = localStorage.getItem("role")?localStorage.getItem("role").replace(/3alxi2fdksjfkljwijljsk128ldfln324kodnvjdsl32432jfiwefjls32432idaxpoife983iw2/g,''):'';//获取当前用户角色
			
		},

	}
</script>

<style scoped="scoped">

</style>
